import { z } from 'zod';
import { companyRelationSchema } from '@/schemas/companySchema';

export type OfficeResultType = z.infer<typeof officeDetailSchema>;
export type OfficeDetailType = z.infer<typeof officeDetailSchema>;
export type OfficeRelationType = z.infer<typeof officeRelationSchema>;

export const officeRelationSchema = z.object({
  id: z.number(),
  name: z.string(),
  shortName: z.string(),
});

export const officeDetailSchema = z.object({
  id: z.number(),
  name: z.string(),
  shortName: z.string(),
  postOffice: z.string(),
  description: z.string(),
  availability: z.string(),
  streetAddress: z.string(),
  postalCode: z.string(),
  email: z.string(),
  phone: z.string(),
  company: companyRelationSchema,
});
